import JobApplicationDialog from 'components/Dialogs/JobApplicationDialog';
import HubertConfirmationDialog from 'components/HubertUI/HubertConfirmationDialog';
import CreateTemplateDialog from './CreateTemplateDialog';
import CreateClientDialog from './CreateClientDialog';
import EditQuestionDialog from './EditQuestionDialog';

const DialogsContainer = () => {
  return (
    <>
      <EditQuestionDialog />
      <CreateTemplateDialog />
      <CreateClientDialog />
      <JobApplicationDialog />
      <HubertConfirmationDialog />
    </>
  );
};

export default DialogsContainer;
